import React from 'react';

const YELLOW = '#FFEB00';
const CIRCLE = 35;

const STEPS = [
    { num: '01', label: 'Listing' },
    { num: '02', label: 'Listing Items' },
    { num: '03', label: 'Sort and Initialize Pricing' },
];

function TradeInStepper({ currentStep }) {
    return (
        <div style={{
            display: 'flex',
            alignItems: 'flex-start',
            padding: '20px 100px',
            marginBottom: '12px',
            borderRadius: '8px',
            background: 'white',
            boxSizing: 'border-box',
        }}>
            {STEPS.map((step, idx) => {
                const isActive = idx + 1 === currentStep;
                const isDone   = idx + 1 < currentStep;

                const leftBlack  = idx + 1 <= currentStep;
                const rightBlack = idx + 2 <= currentStep;

                const lineBackground =
                    leftBlack && rightBlack
                        ? '#212529'
                        : leftBlack
                            ? 'linear-gradient(to right, #212529 50%, #CED4DA 50%)'
                            : rightBlack
                                ? 'linear-gradient(to right, #CED4DA 50%, #212529 50%)'
                                : '#CED4DA';

                return (
                    <React.Fragment key={step.num}>
                        {/* ── Step block: circle + label ── */}
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, width: CIRCLE, overflow: 'visible', flexShrink: 0 }}>
                            <div style={{
                                width: CIRCLE, height: CIRCLE,
                                borderRadius: '50%',
                                background: isActive ? YELLOW : isDone ? YELLOW : 'transparent',
                                border: isActive || isDone ? 'none' : '1px solid #CED4DA',
                                color: isActive ? '#000' : isDone ? '#000' : '#CED4DA',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                fontWeight: 600, fontSize: 16, fontFamily: 'Montserrat',
                                boxSizing: 'border-box',
                                flexShrink: 0,
                            }}>
                                {step.num}
                            </div>
                            <span style={{
                                fontSize: 16,
                                fontWeight: 600,
                                color: isActive || isDone ? '#212529' : '#6C757D',
                                fontFamily: 'Montserrat',
                                whiteSpace: 'nowrap',
                                textAlign: 'center',
                            }}>
                                {step.label}
                            </span>
                        </div>

                        {/* ── Connector line ── */}
                        {idx < STEPS.length - 1 && (
                            <div style={{
                                flex: 1,
                                height: '1px',
                                background: lineBackground,
                                alignSelf: 'flex-start',
                                marginTop: CIRCLE / 2,
                            }} />
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
}

export default TradeInStepper;
